import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mapRef } from '../map/mapRef';
import type { Basemap } from '../map/controller';
import { IconGlobe, IconMap } from './icons';

// Map-view toggle, stacked below the burger. Icon-only; the icon reflects the CURRENTLY active
// basemap (folded map = vector, globe = satellite). Tapping switches to the other view.
export function MapStyleButton() {
  const { t } = useTranslation();
  const [bm, setBm] = useState<Basemap>('vector');
  const next: Basemap = bm === 'vector' ? 'satellite' : 'vector';
  const toggle = () => {
    mapRef.current?.setBasemap(next);
    setBm(next);
  };
  return (
    <button
      onClick={toggle}
      aria-label={t(`map.${next}`)}
      title={t(`map.${next}`)}
      className="top-safe-stacked pointer-events-auto absolute right-3 flex h-9 w-9 items-center justify-center rounded-full bg-black/55 text-white backdrop-blur active:scale-95"
    >
      {bm === 'vector' ? <IconMap /> : <IconGlobe />}
    </button>
  );
}
